import { useQueryLayer1 } from "../../../layer/chain/useQueryLayer";
import useBindTrigger from "./core/useBindTrigger";

const useTwoWay = (name, props, node) => {
    // const L1 = useQueryLayer1(props)
    useBindTrigger(name, props, node);
}

export default useTwoWay;